import { TranslationMessages } from '../types';
import { app } from './app/es';
import { settingsApp } from './app/es';

const es: TranslationMessages = {
  "nav": {
    "howItWorks": "Cómo funciona",
    "why": "¿Por qué?",
    "features": "Funciones",
    "getStarted": "EMPEZAR",
    "dashboard": "Panel",
    "blog": "Blog"
  },
  "hero": {
    "title1": "Telegram Stars",
    "title2": "Cobra fácilmente",
    "subtitle": "Crea enlaces de pago al instante, gestiona tu saldo y retira a TON. Comisión del 3 %.",
    "cta": "Empezar",
    "hairsim": "Simula tu trasplante capilar"
  },
  "demo": {
    "botName": "Telegram Stars Bot",
    "online": "en línea",
    "linkCreated": "Enlace de pago creado.",
    "invoiceTitle": "Premium Access",
    "invoiceDesc": "Suscripción mensual",
    "stars": "Stars",
    "payBtn": "Pagar 100 Stars",
    "iPayNow": "Pago ahora",
    "paymentLabel": "Pago Telegram Stars",
    "merchant": "Comercio",
    "amount": "Importe",
    "confirmPay": "Confirmar pago",
    "paymentReceived": "Pago recibido — 100 Stars",
    "invoiceCredited": "Invoice #xk9m2 · acreditado al saldo",
    "thanks": "Gracias, acceso activado",
    "messagePlaceholder": "Mensaje"
  },
  "stats": {
    "title": "La confianza de miles de agentes",
    "subtitle": "Únete a una comunidad de comercios que usan pagos con Telegram Stars",
    "activeAgents": "Agentes activos",
    "transactions": "Transacciones",
    "uptime": "Disponibilidad",
    "support": "Soporte"
  },
  "features": {
    "title": "Todo lo necesario para aceptar Telegram Stars",
    "subtitle": "Una plataforma completa para gestionar tus pagos Telegram Stars",
    "instantTitle": "Creación instantánea",
    "instantDesc": "Conviértete en agente en segundos. Sin configuración.",
    "balanceTitle": "Gestión del saldo",
    "balanceDesc": "Sigue tus ingresos en tiempo real con un panel intuitivo.",
    "paymentsTitle": "Pagos Telegram Stars",
    "paymentsDesc": "Acepta pagos en Telegram Stars con tu bot.",
    "securityTitle": "Máxima seguridad",
    "securityDesc": "Ledger inmutable, transacciones seguras y transparentes.",
    "withdrawTitle": "Retiros TON",
    "withdrawDesc": "Retira tus fondos directamente a tu dirección TON.",
    "apiTitle": "API robusta",
    "apiDesc": "Integración fácil con webhooks y una API REST completa."
  },
  "how": {
    "title": "Cómo funciona",
    "subtitle": "Empieza en 3 pasos sencillos",
    "startDemo": "Iniciar demo",
    "demoRunning": "Demo en curso...",
    "reset": "Reiniciar",
    "step1Title": "1. Registrarse",
    "email": "Email",
    "password": "Contraseña",
    "noCard": "✓ No se requiere tarjeta",
    "step2Title": "2. Crear enlaces de pago",
    "amountStars": "Importe (Stars)",
    "generatedLink": "Enlace generado:",
    "shareLink": "✓ Comparte este enlace con tus clientes",
    "step3Title": "3. Retirar tus fondos",
    "tonAddress": "Dirección TON",
    "availableBalance": "Saldo disponible:",
    "fee": "Comisión: 3 %"
  },
  "pricing": {
    "title": "Precios simples y transparentes",
    "subtitle": "Sin costes ocultos, sin compromiso",
    "commission": "Comisión",
    "perTransaction": "por transacción",
    "freeAccount": "Cuenta gratuita",
    "noMonthly": "Sin cuotas mensuales",
    "tonWithdrawals": "Retiros TON integrados",
    "completeDashboard": "Panel completo",
    "support247": "Soporte 24/7",
    "startNow": "Empezar ahora"
  },
  "faq": {
    "title": "Preguntas frecuentes",
    "subtitle": "Todo sobre los pagos con Telegram Stars",
    "q1": "¿Cómo funciona el pago con Telegram Stars?",
    "a1": "Los comercios crean enlaces de pago, los comparten con clientes y reciben pagos en Telegram Stars.",
    "q2": "¿Cuál es la comisión de la plataforma?",
    "a2": "La comisión es del 3 % por transacción. Sin cuotas de alta ni costes mensuales.",
    "q3": "¿Cómo retiro mis Telegram Stars?",
    "a3": "Puedes solicitar retiros a tu monedero TON. Mínimo: 100 Stars.",
    "q4": "¿Es seguro el pago con Telegram Stars?",
    "a4": "Sí, todos los pagos pasan por el sistema seguro de Telegram con cifrado estándar.",
    "q5": "¿Qué son las Telegram Stars?",
    "a5": "Son una moneda virtual de Telegram para pagar servicios, productos y suscripciones.",
    "q6": "¿Puedo usar Telegram Stars en mi negocio?",
    "a6": "¡Sí! La plataforma está diseñada para comercios, creadores y empresas."
  },
  "cta": {
    "title": "¿Listo para empezar?",
    "subtitle": "Únete a miles de agentes que ya usan nuestra plataforma",
    "createAccount": "Crear cuenta gratis",
    "signIn": "Iniciar sesión"
  },
  "footer": {
    "description": "Plataforma SaaS completa para pagos con Telegram Stars",
    "product": "Producto",
    "features": "Funciones",
    "pricing": "Precios",
    "support": "Soporte",
    "signIn": "Iniciar sesión",
    "docs": "Documentación",
    "copyright": "© 2024 Telegram Stars Payment Platform. Todos los derechos reservados."
  },
  "seo": {
    "title": "Plataforma de pagos Telegram Stars | Acepta pagos con Stars",
    "description": "Acepta pagos vía Telegram Stars. Crea enlaces al instante, gestiona tu saldo y retira a TON. Comisión 3 %.",
    "keywords": "pago telegram stars, aceptar telegram stars, plataforma pagos telegram stars"
  },
  "whyPage": {
    "seoTitle": "Por qué elegir Telegram Stars Payment Platform",
    "seoDescription": "Descubre por qué los comercios eligen nuestra plataforma: configuración instantánea, precios transparentes y pagos seguros.",
    "title": "¿Por qué elegirnos?",
    "subtitle": "Hecho para comercios y creadores que quieren pagos Telegram Stars simples",
    "r1Title": "Configuración instantánea",
    "r1Desc": "Empieza en segundos. Sin configuración compleja.",
    "r2Title": "Precios transparentes",
    "r2Desc": "Solo 3 % por transacción. Sin costes ocultos.",
    "r3Title": "Seguro y fiable",
    "r3Desc": "Basado en la infraestructura de pagos segura de Telegram.",
    "r4Title": "Alcance global",
    "r4Desc": "Acepta pagos de usuarios de Telegram en todo el mundo.",
    "r5Title": "Integración fácil",
    "r5Desc": "API y webhooks simples. Integra tus sistemas en minutos.",
    "r6Title": "Retiros TON",
    "r6Desc": "Retira directamente a tu monedero TON."
  },
  "howPage": {
    "seoTitle": "Cómo funciona | Telegram Stars Payment Platform",
    "seoDescription": "Aprende a aceptar pagos Telegram Stars en 3 pasos sencillos.",
    "title": "Cómo funciona",
    "subtitle": "Acepta pagos Telegram Stars en tres pasos sencillos"
  },
  "settings": {
    "title": "Ajustes",
    "languageSection": "Idioma",
    "defaultLanguage": "Idioma predeterminado",
    "languageHint": "Este idioma se aplica a toda la plataforma (páginas públicas e interfaz).",
    "languageSaved": "Idioma actualizado",
    ...settingsApp,
  },
  app,
};

export default es;
